import { Box, Stack } from '@mui/material'
import { SearchX, Home, ArrowLeft } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

import { Button } from '@repo/ui'
import { EmptyState } from 'components'
import { ROUTES } from 'routes'
import { vhMinus } from 'utils/textZoom'

/**
 * 404 page. Inside the app it renders as an empty-placeholder inside the Layout
 * content area (sidebar stays visible); `fullScreen` covers the viewport for the
 * unauthenticated / outside-Layout catch-all.
 */
export const NotFoundPage = ({ fullScreen = false }: { fullScreen?: boolean }) => {
  const navigate = useNavigate()

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 4,
        height: fullScreen ? vhMinus() : '100%',
        minHeight: fullScreen ? vhMinus() : '70vh',
      }}
    >
      <EmptyState
        icon={<SearchX strokeWidth={1} size={32} />}
        title="Page not found"
        text="We couldn't find the page you're looking for. It may have been moved, renamed, or never existed."
        buttons={
          <Stack direction="row" spacing={3} alignItems="center">
            <Button
              variant="secondary"
              disableElevation
              onClick={() => navigate(-1)}
              startIcon={<ArrowLeft size={16} strokeWidth={1.75} />}
            >
              Go back
            </Button>
            <Button
              variant="primary"
              disableElevation
              onClick={() => navigate(ROUTES.HOME)}
              startIcon={<Home size={16} strokeWidth={1.75} />}
            >
              Go to home
            </Button>
          </Stack>
        }
      />
    </Box>
  )
}
